'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _next = require('@alifd/next');

var _vuFusionField = require('../common/vu-fusion-field');

var _vuFusionField2 = _interopRequireDefault(_vuFusionField);

var _formFieldUtils = require('../common/formFieldUtils');

require('./view.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var CheckboxField = (_temp = _class = function (_Field) {
  _inherits(CheckboxField, _Field);

  function CheckboxField() {
    _classCallCheck(this, CheckboxField);

    return _possibleConstructorReturn(this, _Field.apply(this, arguments));
  }

  CheckboxField.prototype.getProps = function getProps() {
    return _extends({}, this.props, {
      fieldClassName: 'vc-checkbox'
    });
  };

  CheckboxField.prototype.getControlProps = function getControlProps() {
    var _props = this.props,
        showSearch = _props.showSearch,
        notFoundContent = _props.notFoundContent;

    var superProps = _Field.prototype.getControlProps.call(this);

    return _extends({}, superProps, {
      style: _extends({}, superProps.style, { width: '100%' }),
      showSearch: showSearch,
      notFoundContent: notFoundContent,
      dataSource: this.getOptions(true),
      itemDirection: this.itemDirection
    });
  };

  CheckboxField.prototype.renderControl = function renderControl() {
    var controlProps = this.getControlProps();
    return _react2.default.createElement(_next.Checkbox.Group, controlProps);
  };

  _createClass(CheckboxField, [{
    key: 'itemDirection',
    get: function get() {
      var displayStyle = this.props.displayStyle;

      if (displayStyle === 'horizontal') {
        return 'hoz';
      } else if (displayStyle === 'vertical') {
        return 'ver';
      }
      return displayStyle;
    }
  }]);

  return CheckboxField;
}(_vuFusionField2.default), _class.displayName = 'Checkbox', _class.defaultProps = _extends({}, _vuFusionField2.default.defaultProps, { displayStyle: 'horizontal' }), _class.mutableStates = [].concat(_toConsumableArray(_vuFusionField2.default.mutableStates), ['dataSource', {
  name: 'fieldData',
  formatIn: function formatIn() {
    var fieldData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var props = arguments[1];
    var states = arguments[2];
    var dataType = arguments[3];

    var defaultItems = (0, _formFieldUtils.getDefaultOptions)(states.options.value);
    if (!(0, _lodash.isEmpty)(fieldData.value)) {
      return fieldData;
    } else {
      return _extends({}, fieldData, { value: defaultItems });
    }
  }
}]), _temp);
exports.default = CheckboxField;
module.exports = exports['default'];